(function loadSweetAlert () {
  if (window.Swal) return;       
  const css  = document.createElement('link');
  css.rel  = 'stylesheet';
  css.href = 'https://cdn.jsdelivr.net/npm/sweetalert2@11/dist/sweetalert2.min.css';

  const js   = document.createElement('script');
  js.src  = 'https://cdn.jsdelivr.net/npm/sweetalert2@11/dist/sweetalert2.min.js';
  js.defer = true;

  document.head.appendChild(css);
  document.head.appendChild(js);
})();


/*──────────────────  VARIABLES GLOBALES  ──────────────────*/      
let valores   = {};       

/*──────────────────  HELPERS  ──────────────────*/
const $  = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));
const err = id => document.getElementById(id);

/*──────────────────  SANITIZAR NÚMEROS  ──────────────────*/
['inputAge', 'inputWeightK'].forEach(id => {
  const el = document.getElementById(id);
  el.addEventListener('input', e => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  });
});

/*──────────────────  SELECCIÓN ACTIVIDAD  ──────────────────*/
let actividad = -1;   // −1 => nada elegido aún

document
  .querySelectorAll('.customjey__actividad-option-img')  
  .forEach(card => {
    card.addEventListener('click', () => {

      document
        .querySelectorAll('.customjey__actividad-option-img')   
        .forEach(c => c.classList.remove('active'));

      card.classList.add('active');
      actividad = parseInt(card.dataset.act ?? card.title, 10);

      document.getElementById('errorActivity').textContent = '';
    });
  });

/* fallback si tu markup sigue usando changeTab(idx) */
function changeTab (idx) {
  actividad = parseInt(idx, 10);

  document
    .querySelectorAll('.customjey__actividad-option-img')   
    .forEach(el => {
      const val = parseInt(el.dataset.act ?? el.title, 10);
      el.classList.toggle('active', val === actividad);
    });

  document.getElementById('errorActivity').textContent = '';
}


/*──────────────────  VALIDACIONES LIVE  ──────────────────*/
$('#inputAge').addEventListener('input', () => {
  const v = parseInt($('#inputAge').value,10);
  err('errorAges').textContent = (isNaN(v)||v<18)?'Debes tener al menos 18 años':'';
});
$('#inputWeightK').addEventListener('input', () => {
  const v = parseFloat($('#inputWeightK').value);
  err('errorWeight').textContent = (isNaN(v)||v<=0)?'Tu peso es requerido':'';
});
$('#selectGender').addEventListener('change', e=>{
  err('errorGender').textContent = e.target.value?'':'Selecciona tu género';
});
$('#selectClimate').addEventListener('change', e=>{
  err('errorClimate').textContent = e.target.value?'':'Elige el clima donde vives';
});

/*──────────────────  FUNCIÓN PRINCIPAL  ──────────────────*/
function calculateElectrolytes () {

  /* limpiar mensajes previos */
  ['errorAges','errorWeight','errorGender','errorClimate','errorActivity']
    .forEach(id=>err(id).textContent='');

  const age     = parseInt($('#inputAge').value,10);
  const weight  = parseFloat($('#inputWeightK').value);
  const gender  = $('#selectGender').value;
  const climate = $('#selectClimate').value;
  const keto    = $('#ketoCheck').checked;
  const diur    = $('#diurCheck').checked;

  /* validaciones */
  let ok = true;
  if(isNaN(age)||age<18){ err('errorAges').textContent='Debes tener al menos 18 años'; ok=false; }
  if(isNaN(weight)||weight<=0){ err('errorWeight').textContent='Tu peso es requerido'; ok=false; }
  if(!gender){ err('errorGender').textContent='Selecciona tu género'; ok=false; }
  if(!climate){ err('errorClimate').textContent='Elige el clima donde vives'; ok=false; }
  if(actividad<0){ err('errorActivity').textContent='Elige tu nivel de actividad'; ok=false; }
  if(!ok) return;

  /* cálculo electrolitos */
  let na = 1500, k = 2600, mg = 320;

  if(gender==='M'){ k+=800; mg+=100; }
  
  if(actividad==0){ na+=600; k+=400; mg+=200; }
  if(actividad==1){ na+=300; k+=200; mg+=100; }
  //if(actividad==2){ na+=600; k+=400; mg+=200; }

  if(climate==='templado'){ na+=50; k+=100; }
  if(climate==='calido'){ na+=500; k+=300; mg+=100; }

  if(keto){ na+=600; k+=500; mg+=100; }
  if(diur){ na+=200; k+=100; mg+=100; }

  /* guardar en variable global para uso posterior */
  valores = { age, weight, gender, climate, actividad, keto, diur, na, k, mg };

  /* pasar a modal 0 */
  // $('#titleModal').textContent = 'Para darte un resultado más preciso…';
  // $('#contentModal').innerHTML = '<p>¿Consideras que tu peso actual está dado principalmente por músculo o por grasa?</p>';
  // openModal(0);
  openModal(1);
}

/*──────────────────  MODAL 0  (músculo / grasa)  ──────────────────*/
function changeValue (num) {
  const musculo = $('#musculo-calculadora');
  const grasa   = $('#grasa-calculadora');
  if(num==0){
    valores.composicionCorporal = 'Musculo';
    musculo.classList.add('customjey__active-musculo');
    grasa.classList.remove('customjey__active-musculo');
  }else{
    valores.composicionCorporal = 'Grasa';
    grasa.classList.add('customjey__active-musculo');
    musculo.classList.remove('customjey__active-musculo');
  }
  /* botón calcular dentro de modal 0 */
  const btn = $('#modalButton');
  btn.innerHTML = '<span class="calculadora-button" style="cursor:pointer">Calcular</span>';
  btn.querySelector('span').onclick = ()=>{ closeModal(0); openModal(1); };
}

/*──────────────────  MODALES genéricos  ──────────────────*/
function openModal(id){ document.getElementById(`myModal${id}`).style.display='block'; }
function closeModal(id){ document.getElementById(`myModal${id}`).style.display='none'; }

/*──────────────────  ENVÍO FORMULARIO (modal 1)  ──────────────────*/
function validateFormModal () {

  const errs = {}; const rxMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const nombre   = $('#namemodal').value.trim();
  const apellido = $('#lastnamemodal').value.trim();
  const email    = $('#emailmodal').value.trim();
  const phone    = $('#phonemodal').value.trim();
  const phoneCd  = document.querySelector('.iti__selected-dial-code')?.textContent || '';
  const termsOK  = $('#termsCheckbox').checked;
  const fraseSel = $('#preguntaAdicional')?.value || '';

  if (!nombre)             errs.errormodalname     = 'Requerido';
  if (!apellido)           errs.errormodallastname = 'Requerido';
  if (!rxMail.test(email)) errs.errormodalemail    = 'Correo inválido';
  if (phone.length < 5)    errs.errormodalphone    = 'Teléfono inválido';
  if (!termsOK)            errs.errormodalterms    = 'Debes aceptar';

   const motivationSanitized = fraseSel
    .replace(/\r?\n/g, ' ')  // Reemplazar saltos de línea con espacios
    .replace(/\s+/g, ' ')    // Reemplazar múltiples espacios con uno solo
    .trim();
  $$('.error-message').forEach(el => el.textContent = '');
  Object.entries(errs).forEach(([id, msg]) => { $('#' + id).textContent = msg; });

  if (Object.keys(errs).length) return;

  const payload = {
    firstName: nombre,
    lastName : apellido,
    email,
    phone,
    phonecode       : phoneCd,
    age             : String(valores.age),
    gender          : valores.gender,
    weightKg        : String(valores.weight),
    climate         : valores.climate,
    activity        : valores.actividad == 0 ? 'Muy activo' :
                      valores.actividad == 1 ? 'Activo'      : 'Poco activo',
    keto            : valores.keto,
    diuretics       : valores.diur,
    sodiumMg        : valores.na,
    potassiumMg     : valores.k,
    magnesiumMg     : valores.mg,
    bodyComposition : valores.composicionCorporal,
    motivation      : motivationSanitized,           
    smsMarketingConsent : true
  };

/*──────────────────  ENVÍO  ──────────────────*/
SavvyCalculadora.submit('electrolytes', payload)
  .then(() => {
    closeModal(1);
    localStorage.setItem('calculadoraElectrolitos',
                         JSON.stringify({nombre: nombre, na: valores.na, k: valores.k, mg: valores.mg }));

    Swal.fire({
      icon: 'success',
      title: '¡Estamos calculando tus resultados!',
      text:  '',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    }).then(() => {
      window.location.href =
      '/discount/ELECTROLITOS?redirect=%2Fpages%2Fresultado-electrolitos';
    });
  })
  .catch(error => {
    console.error('Electrolytes calculator submit failed:', error.code, error.operation, error.message, error.errors);

    closeModal(1);

    const shown = SavvyCalculadora.errorMessage(error);

    Swal.fire({
      icon: 'error',
      title: shown.title,
      text:  shown.text,
      confirmButtonColor: '#000'
    });
  });
}


/*──────────────────  DISABLE PLACEHOLDERS EN SELECTS  ──────────────────*/
document.addEventListener('DOMContentLoaded', ()=>{
  $$('select').forEach(sel=>{
    const opt=sel.options[0];
    if(opt && opt.value.trim()===''){ opt.disabled=true; opt.hidden=true; }
  });
});
